<template>
  <teleport to="body">
    <div v-show="visible" class="loading-overlay">
      <div class="loading-box">
        <div class="spinner-border text-primary mb-3"></div>
        <h6 class="mb-1">{{ title }}</h6>
        <p class="text-muted mb-0">{{ message }}</p>
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'LoadingModal',
  props: {
    visible: { type: Boolean, required: true },
    title:   { type: String, default: 'Carregando dados' },
    message: { type: String, default: 'Aguarde um momento...' }
  },
};
</script>

<style scoped>
.loading-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-box {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  min-width: 400px;
  width: 90%;
  max-width: 500px;
}

@media (max-width: 576px) {
  .loading-box {
    padding: 1.2rem;
    max-width: 350px ;
    min-width: 350px;
  }
}

</style>